import { PlayerProperty, Save, Restore } from '../PlayerProperty';
import IPlayerData from '../../IPlayerData';
import { IPlayerState } from '../../../State/Player/IPlayerState';
import { restoreString } from '../../ParseHelper';
import { initialPlayerState } from 'State/Player/initialPlayerStates';

type PlayerStateKey = 'attributionCampaignID';
type PlayerDataKeys = 'v1_84_0_mAdName';
export default class AdCampaign implements PlayerProperty<PlayerStateKey, PlayerDataKeys> {
    public isChanged(playerStateData: IPlayerState, playerEndpointData: IPlayerData): boolean {
        return playerEndpointData.v1_84_0_mAdName !== playerStateData.attributionCampaignID;
    }

    public restore(playerEndpointData: IPlayerData): Restore<PlayerStateKey> {
        const defaultValue = initialPlayerState.attributionCampaignID;
        const restoredString = restoreString(playerEndpointData.v1_84_0_mAdName, defaultValue);
        return restoredString !== '' ? restoredString : defaultValue;
    }

    public save(playerStateData: IPlayerState): Save<PlayerDataKeys> {
        return {
            v1_84_0_mAdName: playerStateData.attributionCampaignID,
        };
    }
}
